import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class FontService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listFonts = ({ categoryID, page, keyword }) => {
    const request = {
      method: 'GET',
      url: '/fonts',
      params: {
        category_id: categoryID,
        page,
        max_results: 30,
        keyword,
      },
    };
    return this.axios(request);
  };

  insertDbOfFont = (params) => {
    const { uploadKeys, subCat } = params;
    const request = {
      method: 'POST',
      url: '/fonts',
      data: {
        fonts: uploadKeys,
        // category_id: subCat,
      },
    };
    return this.axios(request);
  };

  getUrlOfItem = (id) => {
    const request = {
      method: 'POST',
      url: '/fonts/download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  checkFonts = ({ fontFamilies, isImportSvg = false, fontIds = null }) => {
    const request = {
      method: 'POST',
      url: '/fonts/check',
      data: {
        fontFamilies,
        isImportSvg,
        fontIds,
      },
    };
    return this.axios(request);
  };
}

export default new FontService();
